import React, { useState } from "react";
import { Lock } from "lucide-react";
import BetaRequestModal from "@/components/admin/BetaRequestModal";

export default function LockedFeatureCard({
    title,
    description,
    badge = "Pro",
    icon: Icon,
    actionLabel = "Upgrade plan",
    onAction,
    testid = "locked-feature",
    feature,
}) {
    const [modalOpen, setModalOpen] = useState(false);

    const handleClick = () => {
        if (onAction) return onAction();
        setModalOpen(true);
    };

    return (
        <>
            <div
                className="bg-white border border-stone-200 rounded-xl p-8 max-w-3xl mb-6"
                data-testid={testid}
            >
                <div className="flex items-start gap-5">
                    {Icon && (
                        <div className="w-14 h-14 rounded-xl bg-orchid-700/10 flex items-center justify-center shrink-0">
                            <Icon className="text-orchid-700" size={24} />
                        </div>
                    )}
                    <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                            <h2 className="font-heading text-2xl text-orchid-700">{title}</h2>
                            {badge && (
                                <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-gold-500/15 text-gold-700 border border-gold-500/30">
                                    {badge}
                                </span>
                            )}
                        </div>
                        <p className="text-stone-600 text-sm leading-relaxed mb-6">
                            {description}
                        </p>
                        <button
                            type="button"
                            onClick={handleClick}
                            data-testid={`${testid}-action`}
                            className="inline-flex items-center gap-2 text-sm font-medium px-5 py-2.5 rounded-md bg-orchid-700 hover:bg-orchid-600 text-white transition-colors"
                        >
                            <Lock size={14} />
                            {actionLabel} →
                        </button>
                    </div>
                </div>
            </div>

            <BetaRequestModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                feature={feature || `locked_${testid.replace(/[^a-z0-9]/gi, "_")}`}
                title={title}
                description={`${title} is part of our ${badge} plan. Tell us a bit about your use case and our sales team will reach out within 1 business day with pricing and access.`}
                submitLabel="Contact sales"
                testid={`${testid}-modal`}
            />
        </>
    );
}
